// Every tag shape sanitizeEventTitleHtml (the write-time sanitizer) can emit: the whitelisted
// elements, optionally with a quoted style attribute free of angle brackets, plus <br>.
const ALLOWED_TAG_PATTERN = /<(?:\/(?:p|div|span|strong|em|u)|(?:p|div|span|strong|em|u)(?:\s+style="[^"<>]*")?|br\s*\/?)\s*>/gi;

/**
 * Render-time trust check for a header event title's rich HTML (eventName.contentHtml).
 *
 * The HTML is sanitized on the admin write paths, but header dataJSON is schemaless on the
 * backend — any other writer could land unsanitized markup in the guest hero, which is injected
 * via dangerouslySetInnerHTML. This guard rejects anything the title editor could not have
 * produced (unknown tags, non-style attributes, event handlers) so the guest falls back to the
 * plain display name instead of rendering it. Deliberately dependency-free — the `xss` package
 * must stay out of the eager guest header (LCP) chunk. It validates markup shape only; CSS
 * property abuse is bounded by the style-attribute charset and cannot execute script.
 */
export const isSafeEventTitleHtml = (html: string): boolean => !/[<>]/.test(html.replace(ALLOWED_TAG_PATTERN, ''));
